
import { mapGetters } from "vuex";
import Form from "./Form.vue";
import AmbienteData from "./AmbienteData";

export default {
  name: "app-restaurante-ambientes-create",
  data() {
    return {
      ambiente: new AmbienteData({}),
    };
  },
  components: {
    Form,
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
  },
};
